// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3355":"7a6c7d5f1b7e94f9","3647":"80a5ed3fe8b38d12"}[chunkId] + ".css";
};